import { render, staticRenderFns } from "./WorkflowJobHistoryTab.vue?vue&type=template&id=a2502454&"
import script from "./WorkflowJobHistoryTab.vue?vue&type=script&lang=ts&"
export * from "./WorkflowJobHistoryTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports